import { useUpdateOfficeVisitMutation } from '../models/ticket.api'

const useUpdateOfficeVisit = () => {
  const [updateOffice, results] = useUpdateOfficeVisitMutation()
  return { updateOffice, results }
}

export default useUpdateOfficeVisit
